import { useEffect, useRef, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const WS_URL = BACKEND_URL.replace(/^http/, "ws") + "/api/ws/alerts";

export function useAlertsWebSocket({ onAlert, enabled = true } = {}) {
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const pingRef = useRef(null);
  const reconnectRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let closed = false;

    const connect = () => {
      const token = localStorage.getItem("aqua_token");
      if (!token) return;
      const ws = new WebSocket(`${WS_URL}?token=${encodeURIComponent(token)}`);
      wsRef.current = ws;

      ws.onopen = () => {
        setConnected(true);
        pingRef.current = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) ws.send("ping");
        }, 25000);
      };

      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg.type === "alert" && onAlert) onAlert(msg);
        } catch (e) { /* ignore */ }
      };

      ws.onclose = () => {
        setConnected(false);
        if (pingRef.current) clearInterval(pingRef.current);
        if (!closed) reconnectRef.current = setTimeout(connect, 3000);
      };
      ws.onerror = () => { try { ws.close(); } catch(e) {} };
    };

    connect();
    return () => {
      closed = true;
      if (pingRef.current) clearInterval(pingRef.current);
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
      if (wsRef.current) try { wsRef.current.close(); } catch(e) {}
    };
  }, [enabled, onAlert]);

  return { connected };
}
